<template>
  <div class="offline">
    <div class="offline-logo">
      <img src="@/assets/images/offline.png" />
    </div>
    <div class="offline-content">
      <p>{{ title }}</p>
      <p>{{ content }}</p>
    </div>
    <div class="offline-button">
      <Button @click="handleClick">{{ buttonText }}</Button>
    </div>
  </div>
</template>
      
<script lang="ts">
import { defineComponent } from "@vue/composition-api";
import { Button } from "mand-mobile";
import { useI18n } from "@/utils/register/i18n";
import { APP_VALUES } from "@/constants/common";
import { WEBSITE_URL } from "./config";

export default defineComponent({
  name: "market-offline",
  components: {
    Button,
  },
  setup() {
    const title = useI18n().t("Fintech_Credit_Test_GEMk_VPjf");
    const content = useI18n().t("Fintech_Credit_Test_drjX_dGLT", {
      Brand_name: APP_VALUES["BRANDNAME"],
    });
    const buttonText = useI18n().t("Fintech_Credit_Test_lWCC_vrZW", {
      Brand_name: APP_VALUES["BRANDNAME"],
    });

    const handleClick = () => {
      window.open(WEBSITE_URL, "_blank");
    };
    return {
      title,
      content,
      buttonText,
      handleClick,
    };
  },
});
</script>
      
<style scoped>
.offline-logo {
  display: flex;
  justify-content: center;
  margin-top: 62px;
}
.offline-logo img{
  width: 136px;
  height: 136px;
}
.offline-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 110px;
  font-family: DiDiSans-Pro-Regular;
  font-size: 46px;
  font-weight: 400;
  color: #4a4a4a;
  letter-spacing: 0;
  text-align: center;
}
.offline-content p:first-child {
  margin-bottom: 50px;
}
.offline-button {
  display: flex;
  justify-content: center;
  margin-top: 192px;
}
.offline-button button {
  width: 618px;
  height: 86px;
  background-image: linear-gradient(86deg, #ff5c1e 0%, #fe7f3e 96%);
  border-radius: 9.97px;
  border: #ffffff;
  font-family: DiDiSans-Pro-Regular;
  font-size: 30px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}
>>> .md-button.default:after {
  border: #ffffff !important;
}
.offline-button button:active,
.offline-button button:focus {
  background: linear-gradient(86deg, #ff5c1e 0%, #fe7f3e 96%) !important;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
}
</style>
      
  